import(/* webpackMode: "eager" */ "/home/iktravels/domains/website/src/app/offers/page.tsx");
